module.exports = __webpack_public_path__ + "red_stripes_r.jpg?ef1808ba776940f762d9c3c1e70d839c";


//////////////////
// WEBPACK FOOTER
// ./src/kits/1/images/red_stripes_r.jpg
// module id = 474
// module chunks = 0